import { Select } from '@shopify/polaris';

export function LabelPrintMethodSelect({ value, onChange, enableZebraOption = true, label = 'Print Method' }) {
    const options = [{ label: 'Download PDF', value: 'pdf' }];

    if (enableZebraOption) {
        options.push({ label: 'Zebra Printer (Cloud Print)', value: 'zebra' });
    }

    return <Select label={label} options={options} value={value} onChange={(next) => onChange(next === 'pdf' ? 'pdf' : 'zebra')} />;
}
